var map = {
	"./mambo.mp3": 3876,
	"./swing.mp3": 3877,
	"./tango.mp3": 3878
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 685;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/dances .\.mp3*
// module id = 685
// module chunks = 0